if (!customElements.get("sc-featured-products")) {
  class ScFeaturedProducts extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll("[data-sc-featured-slide]"));
      this.dotsRoot = this.querySelector("[data-sc-featured-dots]");
      const activeIndex = this.slides.findIndex((slide) => !slide.hidden);
      this.index = activeIndex >= 0 ? activeIndex : 0;
      this.tracking = false;
      this.buildDots();
      this.querySelector("[data-sc-featured-prev]")?.addEventListener("click", () => {
        this.go(this.index - 1);
      });
      this.querySelector("[data-sc-featured-next]")?.addEventListener("click", () => {
        this.go(this.index + 1);
      });
      this.addEventListener("pointerdown", this.onPointerDown);
      this.addEventListener("pointerup", this.onPointerUp);
      this.addEventListener("pointercancel", this.onPointerCancel);
      this.show(this.index);
    }

    disconnectedCallback() {
      this.removeEventListener("pointerdown", this.onPointerDown);
      this.removeEventListener("pointerup", this.onPointerUp);
      this.removeEventListener("pointercancel", this.onPointerCancel);
    }

    buildDots() {
      if (!this.dotsRoot) return;
      this.dotsRoot.replaceChildren();
      this.dots = this.slides.map((slide, index) => {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "sc-featured-products__dot";
        button.setAttribute(
          "aria-label",
          slide.dataset.scFeaturedLabel || String(index + 1)
        );
        button.addEventListener("click", () => this.go(index));
        this.dotsRoot.append(button);
        return button;
      });
    }

    go(index) {
      const count = this.slides.length;
      if (!count) return;
      this.show((index + count) % count);
    }

    show(index) {
      this.index = index;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle("is-active", active);
        slide.hidden = !active;
        slide.setAttribute("aria-hidden", active ? "false" : "true");
      });
      this.dots?.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle("is-active", active);
        if (active) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });

      const activeSlide = this.slides[index];
      requestAnimationFrame(() => {
        activeSlide.querySelectorAll("css-slider").forEach((slider) => {
          if (typeof slider.resetSlider === "function") slider.resetSlider(true);
        });
      });
    }

    onPointerDown = (event) => {
      if (
        event.target.closest(
          "css-slider, a, button, input, select, textarea, label, product-form"
        )
      ) {
        this.tracking = false;
        return;
      }
      this.tracking = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
    };

    onPointerUp = (event) => {
      if (!this.tracking) return;
      this.tracking = false;
      const deltaX = event.clientX - this.startX;
      const deltaY = event.clientY - this.startY;
      if (Math.abs(deltaX) < 50 || Math.abs(deltaX) < Math.abs(deltaY)) return;
      this.go(this.index + (deltaX < 0 ? 1 : -1));
    };

    onPointerCancel = () => {
      this.tracking = false;
    };
  }

  customElements.define("sc-featured-products", ScFeaturedProducts);
}
